import { query, collection, onSnapshot, addDoc, deleteDoc, doc, setDoc } from "firebase/firestore";
import { db, getCompanyId, getCurrentUserUID, sendError, getCurrentUser } from "./firebase";

const listeners: CallableFunction[] = [];
var snapshotListener: Function | null = null;
var lastSnapshotList: any[] = [];
var lastSnapshotMap = new Map();

export function registerSmsTemplateSnapshotListener() {
    if (snapshotListener !== null) {
        return;
    }
    const q = query(collection(db, 'companies/' + getCompanyId() + '/smsTemplates'));
    //console.log("register smsTemplatesListener");
    snapshotListener = onSnapshot(q, (data: any) => {
        var list: { id: string; sender: string; topic: string; text: string, owner: string, public: boolean, default: boolean, reminder:boolean }[] = [];
        lastSnapshotMap.clear();
        data.forEach(function (doc: any) {

            let e = { id: doc.id, sender: doc.data().sender, topic: doc.data().topic, text: doc.data().text, owner: doc.data().owner, public: doc.data().public, default: doc.data().default, reminder:doc.data().reminder??false };
            list.push(e);
            lastSnapshotMap.set(doc.id, e);

        });
        lastSnapshotList = list;
        listeners.forEach(callback => {
            callback(list);
        });


    }, (err) => {
        console.log("onSmsTemplateChange error => " + err.message);
        sendError(err.message);
    })
}

export async function unregisterSmsTemplateSnapshotListener() {
    if (snapshotListener !== null) {
        //console.log("unregister unregisterSmsTemplateSnapshotListener");
        await snapshotListener();
        snapshotListener = null;
    }
}

export async function addSmsTemplateListener(callback: CallableFunction) {
    listeners.push(callback);
    if (lastSnapshotList.length > 0) {
        callback(lastSnapshotList);
    }
}



export function getSmsTemplates(all: boolean = false) {
    if (all) {
        return lastSnapshotList;
    } else {
        var l: any[] = [];
        lastSnapshotList.map((i) => {
            if (getCurrentUser().smsTemplates.includes(i.id)) {
                l.push(i);
            }
        })

        return l;
    }
}

export function getSmsTemplate(id: string) {
    return lastSnapshotMap.get(id);
}

export async function addSmsTemplate(data: { default: boolean, reminder:boolean, sender: string | number, text: string, topic: string | number }) {

    try {
        //@ts-ignore
        data.owner = getCurrentUserUID();
        await addDoc(collection(db, 'companies/' + getCompanyId() + '/smsTemplates'), data);
    } catch (error) {
        console.error(error);
        sendError("Nie mozna dodać szablonu SMS!");
    }
}

export async function setSmsTemplate(data: { default: boolean, sender: string | number, text: string, topic: string | number }, id: string) {
    try {
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/smsTemplates', id), data, { merge: true });
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić szablonu SMS!");
    }
}

export async function deleteSmsTemplate(id: string) {
    try {
        await deleteDoc(doc(db, 'companies/' + getCompanyId() + '/smsTemplates', id));
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć szablonu SMS!");
    }
}